import React, { Suspense, lazy } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import ImpactMetrics from './components/ImpactMetrics';
import VideoSection from './components/VideoSection';
import Repository from './components/Repository';
import NewsSection from './components/NewsSection';
import Partners from './components/Partners';
import Footer from './components/Footer';
import NewsPage from './components/NewsPage';
import SinglePost from './components/SinglePost';
import TeamPage from './components/TeamPage';
import AboutPage from './components/AboutPage';
import HistoryPage from './components/HistoryPage';
import HitTracker from './components/HitTracker';
import StaffPage from './components/StaffPage';
import MapSection from './components/MapSection';
import ProgramSection from './components/ProgramSection';
import PrivacyPolicy from './components/PrivacyPolicy';

const ProgramInklusiPage = lazy(() => import('./components/ProgramInklusiPage'));
const Contributor = lazy(() => import('./components/Contributor'));
const P2MIBKPage = lazy(() => import('./components/P2MIBKPage'));

function LegacyUrlRedirect() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const p = searchParams.get('p');
  if (p) return <Navigate to={`/${p}`} replace />;
  const page = searchParams.get('page');
  if (page === 'about') return <Navigate to="/tentang" replace />;
  if (page === 'news') return <Navigate to="/berita" replace />;
  if (page === 'repository') return <Navigate to="/riset" replace />;
  if (page === 'team') return <Navigate to="/pengurus" replace />;
  if (page === 'staff') return <Navigate to="/staf" replace />;
  if (page === 'sejarah') return <Navigate to="/sejarah" replace />;
  if (page === 'program-inklusi') return <Navigate to="/program-inklusi" replace />;
  if (page === 'p2mi-bk') return <Navigate to="/p2mi-bk" replace />;
  if (page === 'contributor') return <Navigate to="/kontributor" replace />;
  return null;
}

function App() {
  const location = useLocation();
  const canonicalPath = location.pathname;

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Helmet>
        <title>Lembaga Kajian dan Pengembangan Sumber Daya Manusia Nahdlatul Ulama</title>
        <meta name="description" content="Portal resmi Lembaga Kajian dan Pengembangan Sumber Daya Manusia (Lakpesdam) Nahdlatul Ulama." />
        <link rel="canonical" href={`https://lakpesdam.or.id${canonicalPath}`} />
      </Helmet>
      <HitTracker />
      <Navbar />
      <LegacyUrlRedirect />
      <main id="main-content" style={{ flexGrow: 1 }}>
        <Routes>
          <Route path="/" element={
            <>
              <Hero />
              <ImpactMetrics />
              <ProgramSection />
              <MapSection />
              <NewsSection />
              <VideoSection />
              <Partners />
            </>
          } />
          
          <Route path="/tentang" element={<AboutPage />} />
          <Route path="/sejarah" element={<HistoryPage />} />
          <Route path="/pengurus" element={<TeamPage />} />
          <Route path="/staf" element={<StaffPage />} />
          
          <Route path="/riset" element={<Repository />} />
          <Route path="/publikasi" element={<Navigate to="/riset" replace />} />

          <Route path="/program-inklusi" element={
            <Suspense fallback={<div className="flex justify-center items-center min-h-screen"><div className="animate-spin rounded-full h-12 w-12 border-b-2 border-emerald-700"></div></div>}>
              <ProgramInklusiPage />
            </Suspense>
          } />

          <Route path="/p2mi-bk" element={
            <Suspense fallback={<div className="flex justify-center items-center min-h-screen"><div className="animate-spin rounded-full h-12 w-12 border-b-2 border-emerald-700"></div></div>}>
              <P2MIBKPage />
            </Suspense>
          } />
          
          <Route path="/kontributor" element={
            <Suspense fallback={<div className="flex justify-center items-center min-h-screen"><div className="animate-spin rounded-full h-12 w-12 border-b-2 border-emerald-700"></div></div>}>
              <Contributor />
            </Suspense>
          } />
          
          <Route path="/privasi" element={<PrivacyPolicy />} />
          
          <Route path="/berita" element={<NewsPage />} />

          {/* Halaman postingan — /:slug harus di atas wildcard 404 */}
          <Route path="/:slug" element={<SinglePost />} />

          {/* 404 Fallback */}
          <Route path="*" element={
            <div role="alert" style={{display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',minHeight:'100vh',padding:'2.5rem',textAlign:'center'}}>
              <h2 style={{fontSize:'1.875rem',fontWeight:700,marginBottom:'0.5rem',color:'#0f172a'}}>Halaman Tidak Ditemukan</h2>
              <p style={{color:'#64748b',marginBottom:'1.5rem'}}>Maaf, halaman yang Anda cari tidak tersedia.</p>
              <a href="/" style={{backgroundColor:'#047857',color:'white',padding:'0.5rem 1.5rem',borderRadius:'0.5rem',fontWeight:700,textDecoration:'none'}}>Kembali ke Beranda</a>
            </div>
          } />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;
